import { gql } from 'src/generated/gql';

export const GET_ID_VERIFICATION_DATA = gql(`
    query GetIdVerificationData($patientId: String!) {
      staff_getIdVerificationData(patientId: $patientId) {
        identityVerificationStatus {
          value
          label
        }
        identityVerificationDueDate
      }
    }
  `);
